import React, { useEffect, useState, useRef } from "react";
import { Route, Switch, Redirect } from "react-router";
import { useDispatch } from "react-redux";

import * as R from "ramda";

import { useLocation, useHistory } from "react-router-dom";
import { SelfcareMain } from "./main";
import { LoadingState } from "../../_common/loadingState";

import { fetchSelfcareFiles } from "../../actions/funecap/selfcare";
import * as Loadings from "../../constants/loadings/funecap/selfcare";
import { fetchAllPartners, fetchUsersByRole } from "../../actions/backoffice/dossiers";
import { GetPartners, GetPartnersDefaultState } from "../../actions/backoffice/partners";



export const Selfcare = ({ partner, selfcareReducer, user, isPartner }) => {
	const dispatch = useDispatch();
	const searchQuery = useLocation();
	const pageQuery = new URLSearchParams(window.location.search);
	const history = useHistory();
	
	const [teleconseillers, setTeleconseillers] = useState([]);

	let page = pageQuery.get("page");
	let search = pageQuery.get("search");
	let sortBy = pageQuery.get("sortBy");
	let sortDesc = pageQuery.get("sortDesc");
	let operatorId = pageQuery.get("operatorId");
	let fromMeetingDate = pageQuery.get("fromMeetingDate");
	let toMeetingDate = pageQuery.get("toMeetingDate");

	page = R.isNil(page) ? 1 : parseInt(page);
	search = R.isNil(search) ? "" : search;
	sortBy = R.isNil(sortBy) ? "MeetingDate" : sortBy;
	sortDesc = R.isNil(sortDesc) ? "true" : sortDesc;
	operatorId = R.isNil(operatorId) ? "00000000-0000-0000-0000-000000000000" : operatorId;

	const [pageSearch, setPageSearch] = useState(search);

	const routerQuery = {
		page,
		search,
		sortBy,
		sortDesc,
		operatorId,
		fromMeetingDate,
		toMeetingDate,
	};

	useEffect(() => {
		if (isNaN(page) || page === 0) {
			return;
		}

		const query = new URLSearchParams(window.location.search);
		const queryOperatorId = query.get("operatorId");
		if (window.location.search == "" && R.isNil(queryOperatorId)) {
			return;
		}
		const queryFromMeetingDate = pageQuery.get("fromMeetingDate");
		const queryToMeetingDate = pageQuery.get("toMeetingDate");

		dispatch(fetchSelfcareFiles(page, search, sortBy, sortDesc, R.isNil(queryOperatorId) ? "" : queryOperatorId, R.isNil(queryFromMeetingDate) ? "" : queryFromMeetingDate, R.isNil(queryToMeetingDate) ? "" : queryToMeetingDate));
		// eslint-disable-next-line react-hooks/exhaustive-deps

	}, [window.location.search]);

		useEffect(() => {
			if (isNaN(page) || page === 0) {
				history.push("/backoffice/selfcare");
				return;
			}

			dispatch(fetchUsersByRole("etablissement,partner", 1, '', '', '', 'lastName', sortDesc)).then((response)=>{
				setTeleconseillers(response.items);
			})
			dispatch(GetPartnersDefaultState());

			// eslint-disable-next-line react-hooks/exhaustive-deps
		}, [searchQuery.search, history.location]);

	if (selfcareReducer.isLoading.includes(Loadings.FETCHING_SELFCARE_FILES) && R.isNil(selfcareReducer.items)) {
		return <LoadingState />;
	}

	if (R.isNil(selfcareReducer.items)) {
		return "";
	}
	return (
		<Switch>
			<Route exact path="/backoffice/selfcare">
				<SelfcareMain selfcareState={selfcareReducer} pageSearch={pageSearch} setPageSearch={setPageSearch} partnerState={partner} routerQuery={routerQuery} operatorId={operatorId} pageQuery={pageQuery} teleconseillers={teleconseillers} isPartner={isPartner} userId={user?.id} />
			</Route>
			<Route
				render={() => {
					return <Redirect exact to="/backoffice/selfcare" />;
				}}
			/>
		</Switch>
	);
};
